module.exports = __webpack_public_path__ + "static/media/profile_placeholder.1bc6ff0a.png";